import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Control } from 'app/main/models/control.model';
import { ControlService } from 'app/main/services/control.service';
import { first } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  control : Control = null;
  controles: Control[] = [];
  filteredControles: Observable<Control[]>;
  myControl = new FormControl();
  autocomplete = true;
  action: string;
  dataSource : Control[] = [];
  LOCAL_DATA: any;

  constructor(
    private service: ControlService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.LOCAL_DATA = new Control(data.obj);
    this.myControl.setValue(this.LOCAL_DATA);
    this.dataSource = data.dataSource;
    this.action = data.action;
    if('autocomplete' in data)
      this.autocomplete = data.autocomplete;
  }

  doAction(): void{

    if (this.action === 'Add' || this.action === 'Duplicate' ){
      this.addRowData();
    } else if (this.action === 'Update') {
      this.updateRowData();
    } else if (this.action === 'Delete') {
      this.deleteRowData();
    }

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

    this.service.getAll(0,1000).pipe().subscribe(req => {
      this.controles = req.body.map( riesgo => {
        console.log(riesgo);
        return {
          id: riesgo.id,
          nombre: riesgo.nombre,
          categoria: riesgo.categoria

        };
      });

      this.filteredControles = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    });
  }

  private _filter(value: String): Control[] {
      if(typeof value === "string"){
        const filterValue = value.toLowerCase();
        if(value!=undefined && value!="")
          this.LOCAL_DATA.nombre = value;
        return this.controles.filter(option => option.nombre.toLowerCase().includes(filterValue));
      }
      //return this.controles.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);

  }

  displayFn(value?: Control) {
    return value ? this.controles.find(_ => _.id === value.id).nombre : (value!=null ? value.nombre: this.LOCAL_DATA.nombre);
  }

  addRowData(): void {
    console.log('Im here');
    this.LOCAL_DATA.id = null;
    this.service.register(this.LOCAL_DATA).pipe(first()).subscribe(
      data => {
        console.log(data);
        this.LOCAL_DATA = {
                        id: data.body.id,
                        nombre: data.body.nombre,
                        categoria: data.body.categoria
                      };
        if(this.dataSource!=null)
          this.dataSource.push(this.LOCAL_DATA);

        this.dialogRef.close({event: this.action, data: this.LOCAL_DATA,dataSource:this.dataSource});
        this.openSnackBar("Se ingresó el control correctamente.","Cerrar");
      },
      error => {
        console.log(error);
        this.openSnackBar("No se pudo ingresar el control, ocurrió un error.","Cerrar");
      }
    );
  }

  updateRowData(): void {
    this.service.edit(this.LOCAL_DATA.id, this.LOCAL_DATA).pipe(first()).subscribe(
      data => {
        console.log(data);
        if(this.dataSource!=null)
          this.dataSource = this.dataSource.filter((value, key) => {
            if (value.id === this.LOCAL_DATA.id) {
                value.id= data.body.id;
                value.nombre= data.body.nombre;
                value.categoria = data.body.categoria;
                value.bloqueado = data.body.bloqueado;
            }
            return true;
          });
          this.LOCAL_DATA = data.body;
          this.dialogRef.close({event: this.action, data: this.LOCAL_DATA,dataSource:this.dataSource});
          this.openSnackBar("Se actualizó el control correctamente.","Cerrar");
      },
      error => {
        console.log(error);
        this.openSnackBar("No se pudo actualizar el control, ocurrió un error.","Cerrar");
      }
    );
  }

  deleteRowData(): void {
    this.service.delete(this.LOCAL_DATA.id).pipe(first()).subscribe(
      data => {
        console.log(data);
        if(this.dataSource!=null)
          this.dataSource = this.dataSource.filter((value, key) => {
            return value.id !== this.LOCAL_DATA.id;
          });
        this.dialogRef.close({event: this.action, data: this.LOCAL_DATA,dataSource:this.dataSource});
        this.openSnackBar("Se eliminó el control correctamente.","Cerrar");
      },
      error => {
        console.log(error);
        this.openSnackBar("No se pudo eliminar el control, esta asociado a otra entidad.","Cerrar");
      }
    );
  }

  setLocal(option):void{
    this.LOCAL_DATA.nombre = option.nombre;
    this.LOCAL_DATA.categoria = option.categoria;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

}
